<template>
  <div v-if="activeSurvey.id">
    <h2>Analyse {{ activeSurvey.response_count }} Responses</h2>
    <div class="panel" v-if="!activeSurvey.has_multiple_choice_questions">
      <em>There are no questions with multiple choices to analyse</em>
    </div>
    <div v-for="page in aggregateResponse" v-if="page.fields.length > 0">
      <h3>{{ page.title }}</h3>
      <div class="charts panel panel--spacing" v-for="field in page.fields">
        <h3 class="charts__label">{{ field.title }}</h3>
        <template v-if="field.fieldType !== 'opinionrange'">
          <multiple-response-analysis :field="field" :number-of-responses="activeSurvey.response_count" />
        </template>
        <template v-else>
          <opinion-range-analysis :field="field" :number-of-responses="activeSurvey.response_count" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import MultipleResponseAnalysis from './analysis/MultipleResponse';
  import OpinionRangeAnalysis from './analysis/OpinionRange';

  export default {
    name: 'admin-survey-aggregate',

    components: { MultipleResponseAnalysis, OpinionRangeAnalysis },

    computed: {
      ...mapGetters('admin', [
        'activeSurvey',
        'aggregateResponse',
      ]),
    },

    watch: {
      activeSurvey: {
        handler() {
          if (this.activeSurvey.id && !this.activeSurvey.aggregateResponse) {
            this.fetchAggregateResponse(this.activeSurvey.id);
          }
        },
        immediate: true,
      },
    },

    methods: {
      ...mapActions('admin', [
        'fetchAggregateResponse',
      ]),
    },
  };
</script>
